export interface User {
    id: string
    firstName: string
    lastName: string
    imageUrl: string | null
    email: string
    password: string
    role: UserRole
    isPlatformSuperAdmin: boolean
    createdAt: Date
    updatedAt: Date
    deletedAt: Date
    organization?: Organization
}

export interface Organization {
    id: string
    orgName: string
    orgLogo: string
    orgAddress: string
    createdAt: string
    updatedAt: string
    deletedAt: string
}

export interface Device {
    deviceId: number
    deviceName: string
    deviceDescription?: string
    deviceImageUrl: string
    deviceDiagramUrl: string
    dataAccessStartTime: Date
    dataAccessEndTime: Date | null
    status?: DeviceStatus
    createdAt: Date
    updatedAt: Date
    deletedAt: Date
    accumulateData: AccumulateData
    organization?: Organization
}

export interface AccumulateData {
    totalCO2: number
    totalO2: number
    lastCalId: number
    lastUpdatedAt: Date
  }

export enum UserRole {
    user = "user",
    admin = "admin",
    super_admin = "super_admin"
}

export interface DeviceOverall {
    unit_no: string
    inlet_o2: number
    inlet_co2: number
    co2_capture: number
    o2_generated: number
}

export interface RawData {
    timestamp: string
    recordId: number
    co2Inlet: number
    co2Outlet: number
    o2Inlet: number
    o2Outlet: number
    co2TempInlet: number
    co2TempOutlet: number
    o2TempInlet: number
    o2TempOutlet: number
    co2RHInlet: number
    co2RHOutlet: number
    pm25Inlet: number
    pm25Outlet: number
    pm10Inlet: number
    pm10Outlet: number
    deviceId: number
}

export interface Condition {
    line: number
    device: number
    parameter: number
    color: number
}

export enum DeviceStatus {
    ACTIVE = "active",
    OFFLINE = "offline",
}

export enum ResolutionFilter {
    HOURLY = "hourly",
    DAILY = "daily",
    WEEKLY = "weekly",
    MONTHLY = "monthly",
    THIRTYMINS = "30 mins",
    TENMINS = "10 mins",
    FIVEMINS = "5 mins"
}

export type HourlyEntry = {
    name: string;
} & {
    [key in `value_day_${0 | 1 | 2 | 3 | 4 | 5 | 6}`]: number;
};

export type CustomApiResponse = {
    data: { [timestamp: string]: number }[];
    deviceId: number;
    line: number;
    parameter: string;
}[];
  
export interface ChartDataPoint {
    name: string;
    [line: string]: string | number;
  }

export interface RoleMatrix {
  [capability: string]: {
    user: boolean;
    admin: boolean;
    super_admin: boolean;
  };
}

export interface RoleCapability {
  key: string;
  label: string;
  description?: string;
}

export type AlertType = "success" | "error" | "confirm" | "restore" | "transfer";

export type AlertConfig =
  | {
      type: "confirm" | "restore";
      title: string;
      message: string;
      onConfirm?: () => void | Promise<void>;
    }
  | {
      type: "transfer";
      title: string;
      message: string;
      onConfirm?: (organizationId: string) => void | Promise<void>;
    }
  | {
      type: "success" | "error";
      title: string;
      message: string;
    };